import { Box, Button, GridedContent, IconChevronLeft } from '@capitalise/ui-design-system';
import { cloneElement, FunctionComponent, MouseEventHandler } from 'react';
import { use100vh } from 'react-div-100vh';

export interface ImageTitleDescriptionProps {
  title: string;
  lead: string;
  hasPrevious: boolean;
  image?: FunctionComponent<{ width: string; height: string }>;
  onPreviousClick?: MouseEventHandler<HTMLButtonElement>;
  children?: JSX.Element;
}

const ImageTitleDescription = ({
  title,
  lead,
  hasPrevious,
  image,
  onPreviousClick,
  children,
  ...options
}: ImageTitleDescriptionProps) => {
  const Image = image;
  const height = use100vh();

  return (
    <GridedContent>
      <Box gridColumn={{ _: '1/5', sm: '3/7', lg: '5/9' }} display="flex" flexDirection="column">
        {hasPrevious && (
          <Box display="flex" alignSelf="start" pt={{ _: 'xsmall', md: 'medium' }}>
            <Button
              baseColor="green"
              leftIcon={<IconChevronLeft />}
              onClick={onPreviousClick}
              size="small"
              variant="text"
            >
              Previous
            </Button>
          </Box>
        )}
        <Box pt="xsmall" display="flex" justifyContent="center">
          <Image
            width={height > 700 ? '200px' : '140px'}
            height={height > 700 ? '200px' : '140px'}
          />
        </Box>
        <Box paddingY="xsmall">
          <Box typography="heading-32" color="grey-900" pb="3xsmall">
            {title}
          </Box>
          <Box typography="body-18" color="grey-700" dangerouslySetInnerHTML={{ __html: lead }} />
        </Box>
        {children && <Box pb="xsmall">{cloneElement(children, options)}</Box>}
      </Box>
    </GridedContent>
  );
};

export default ImageTitleDescription;
